import styled from "styled-components"

import { minWidth } from "utils"

import Icon from "icons"

export const List = styled.div`
  clear: both;
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;

  ${minWidth.tablet`
    width: auto;
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Title = styled.h2`
  padding-bottom: 0.6rem;
  border-bottom: 0.3rem solid #f3f3f3;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 3rem;
  line-height: 1.333;

  ${minWidth.tablet`
    font-size: 2.8rem;
  `}
`

export const Items = styled.div`
  padding: 1rem 0;
  border-bottom: 0.1rem solid #f3f3f3;
  display: flex;
  flex-direction: column;

  ${minWidth.tablet`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  `}
`

export const ItemWrapper = styled.div`
  width: 100%;
  margin: 1rem 0;

  ${minWidth.tablet`
    width: 47.5%;
  `}
`

export const Category = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.714;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const PromoIcon = styled(Icon)`
  margin-left: 1rem;
`

export const TitleLink = styled.a`
  font-size: 1.6rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.5;
  color: #b5471f;
`

export const ReviewLink = styled.a`
  width: fit-content;
  display: block;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.625;
`

export const ArrowIcon = styled(Icon)`
  position: relative;
  top: 0.3rem;
  left: 0.5rem;
`
